var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99976 0C9.29812 0 9.58427 0.118527 9.79525 0.329505C10.0062 0.540484 10.1248 0.826631 10.1248 1.125V7.875H16.8748C17.1731 7.875 17.4593 7.99353 17.6703 8.2045C17.8812 8.41548 17.9998 8.70163 17.9998 9C17.9998 9.29837 17.8812 9.58452 17.6703 9.7955C17.4593 10.0065 17.1731 10.125 16.8748 10.125H10.1248V16.875C10.1248 17.1734 10.0062 17.4595 9.79525 17.6705C9.58427 17.8815 9.29812 18 8.99976 18C8.70139 18 8.41524 17.8815 8.20426 17.6705C7.99328 17.4595 7.87476 17.1734 7.87476 16.875V10.125H1.12476C0.826387 10.125 0.540239 10.0065 0.329261 9.7955C0.118283 9.58452 -0.000244141 9.29837 -0.000244141 9C-0.000244141 8.70163 0.118283 8.41548 0.329261 8.2045C0.540239 7.99353 0.826387 7.875 1.12476 7.875H7.87476V1.125C7.87476 0.826631 7.99328 0.540484 8.20426 0.329505C8.41524 0.118527 8.70139 0 8.99976 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5db058a8f6a3b27d6fb87d0990123428.svg";
export { ForwardRef as ReactComponent };